import React, { Component } from 'react';
import PropTypes from 'prop-types';

class DeptAnnoucement extends Component {

  static get propTypes() {
    return {
      color: PropTypes.string,
    };
  }

  constructor() {
    super();
    this.state = {
      isSmallScreen: false,
      isSidebarShow: false,
      config: [],
    };
  }

  componentDidMount() {

  }

  render() {
    const{ color } = this.props;
    return (
      <svg xmlns="http://www.w3.org/2000/svg" id="prefix__icon_s_department-announcement" width="30" height="30" viewBox="0 0 30 30">
          <g id="prefix__Group_138" data-name="Group 138" transform="translate(3.75 3.75)">
              <path fill={ color } id="prefix__Path_219" d="M255.759 346.6a.751.751 0 0 1-.724-.556l-2.235-8.334a.75.75 0 1 1 1.449-.388l2.232 8.331a.751.751 0 0 1-.725.944z" className="prefix__cls-1" data-name="Path 219" transform="translate(-242.789 -332.622)"/>
              <path fill={ color } id="prefix__Path_220" d="M243.413 340.5l-3.493-13.036a2.127 2.127 0 0 0-3.543-1.194l-8.66 6.73a4.419 4.419 0 0 0-1.457 4.34l.387 1.446a4.419 4.419 0 0 0 3.427 3.03l.914.132 1.439 5.37a.749.749 0 0 0 .919.53l2.535-.679a.749.749 0 0 0 .53-.918l-1.264-4.72a.749.749 0 0 0-.653-.551l.009-.069s-1.884-.252-2.817-.381c-.471-.065-1.4-.2-1.4-.2a2.9 2.9 0 0 1-2.186-1.93l-.388-1.446a2.945 2.945 0 0 1 .928-2.767l8.661-6.726a.827.827 0 0 1 .726-.221.836.836 0 0 1 .448.619l3.493 13.035a.658.658 0 0 1-.823.931l-3.295-.453a.75.75 0 0 0-.2 1.486l3.295.453a2.938 2.938 0 0 0 .4.029 2.175 2.175 0 0 0 1.668-.7 2.279 2.279 0 0 0 .4-2.14zm-9.731 5.7l-1.081-4.036 1.208.163.96 3.582z" className="prefix__cls-1" data-name="Path 220" transform="translate(-226.141 -325.715)"/>
              <path fill={ color } id="prefix__Path_221" d="M269.489 332.164a.753.753 0 0 1 0-1.063l2.117-2.117a.75.75 0 1 1 1.06 1.061l-2.116 2.116a.75.75 0 0 1-1.061.003z" className="prefix__cls-2" data-name="Path 221" transform="translate(-253.097 -327.62)"/>
              <path fill={ color } id="prefix__Path_222" d="M273.036 342.384a.752.752 0 0 1 .534-.919l2.891-.775a.75.75 0 1 1 .388 1.449l-2.892.775a.75.75 0 0 1-.921-.53z" className="prefix__cls-2" data-name="Path 222" transform="translate(-255.435 -335.058)"/>
              <path fill={ color } id="prefix__Path_223" d="M273.951 352.362a.752.752 0 0 1 .922-.53l2.892.775a.75.75 0 1 1-.388 1.449l-2.892-.775a.75.75 0 0 1-.534-.919z" className="prefix__cls-2" data-name="Path 223" transform="translate(-256.006 -342.023)"/>
          </g>
          <path id="prefix__Rectangle_57" d="M0 0H30V30H0z" data-name="Rectangle 57" style={{ fill: 'none' }}/>
      </svg>

    );
  }
}

export default DeptAnnoucement;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/containers/App/components/Layout/components/DeptAnnoucement/index.js
 **/